import Image from 'next/image';
import { useIntl } from 'react-intl';

import { Modal } from '../../../../design-system/components/modal/Modal';
import { useModal } from '../../../../design-system/components/modal/useModal';
import { RATIO, Ratio } from '../../../../design-system/components/ratio/Ratio';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { imageLoaderForPicture } from '../../../../domains/Layout/Image/URL/ImageURL';
import {
    UgcHighlight,
    UgcHighlightSegment,
} from '../../../../resources/ugcHighlight/domain/types/ugcHighlight';
import { PickDomain } from '../../../utilities/types/PickDomain';

import style from './UGCHighlightModal.module.css';

type UGCHighlightModalProps = {
    isOpen: boolean;
    onClose: () => void;
    ugcHighlight: PickDomain<UgcHighlight, 'id' | 'username' | 'pictures'>;
    segment: UgcHighlightSegment;
};

export function UGCHighlightModal({
    isOpen,
    onClose,
    ugcHighlight,
    segment,
}: UGCHighlightModalProps) {
    const { formatMessage } = useIntl();
    const modalProps = useModal();

    const imageRatio = RATIO['3/4'];

    return (
        <Modal
            {...modalProps}
            isOpen={isOpen}
            onClose={onClose}
            title={formatMessage({ id: 'global.ugc.modal.title' })}
        >
            <div className={style.container}>
                <div className={style.header}>
                    <Typography scale="primary-xl-extra-bold">{ugcHighlight.username}</Typography>
                    <Typography scale="primary-body-regular">
                        {formatMessage({ id: 'global.ugc.modal.subtitleWithSegment' }, { segment })}
                    </Typography>
                </div>
                <div className={style.imageWrapper}>
                    {ugcHighlight.pictures.slice(0, 3).map((picture) => (
                        <Ratio key={picture.id} ratio={imageRatio}>
                            <Image
                                src={picture.id}
                                alt={picture.legend}
                                fill
                                sizes="(min-width: 1200px) 600px, (min-width: 992px) 500px, 300px"
                                loader={imageLoaderForPicture(picture, {
                                    aspectRatio: imageRatio,
                                })}
                                loading="lazy"
                            />
                        </Ratio>
                    ))}
                </div>
            </div>
        </Modal>
    );
}
